var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('panel-title',{attrs:{"title":"预警类型数量统计","width":"196"}}),_c('div',{staticClass:"chart"},[_c('div',{ref:"typeChart"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }